// @flow
'use strict';

import * as React from 'react';

import type { IPisSt } from '../../../../types_imposto';

import OpcoesPisSt from './opcoes_pis_st';

type PisStProps = {
  item : IPisSt,
};

export default function PisSt({ item } : PisStProps) {
  const opcoesPisSt = [];

  Object.keys(item).forEach((i : string) => {
    const Opcao = OpcoesPisSt[i.replace('pis', 'Pis')];
    if (Opcao)
      opcoesPisSt.push(<Opcao key={ i } item={ item[i] }/>);
  });

  return (
      <div id="table-pis-st">
        <h4>PIS ST - PIS Substituição Tributária</h4>
        { opcoesPisSt }
      </div>
  );
}
